import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["terms", "submitButton"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    const termsAccepted = this.hasTermsTarget && this.termsTarget.checked
    this.submitButtonTarget.disabled = !termsAccepted
  }
}
